export default __webpack_public_path__ + "static/media/buttonblue-print.b113e3c7.svg";